import { ReviewItem } from '@/types/api';
import ReviewProfile from './ReviewProfile';
import ReviewBody from './ReviewBody';

const reviewType = {
  positive: { text: '긍정', color: 'text-blue-500', bg: 'bg-blue-50' },
  neutral: { text: '중립', color: 'text-green-500', bg: 'bg-green-50' },
  negative: { text: '부정', color: 'text-red-500', bg: 'bg-red-50' },
};

const LeftContentSection = ({ review }: { review: ReviewItem }) => {
  const hasImage = review.AttachmentList && review.AttachmentList.length > 0;

  return (
    <div className="flex flex-col gap-2">
      {/* 1. 상단 정보 */}
      <ReviewProfile review={review} />
      {/* 2. 리뷰 본문 및 이미지 */}
      <ReviewBody review={review} />
    </div>
  );
};

export default LeftContentSection;
